import { getConsentFromWindow } from "./getConsentFromWindow";
import { getConsentFromCookie } from "./getConsentFromCookie";
import { DEFAULT_CONSENT } from "../constants";

/**
 * Get the current consent.
 *
 * First attempts to retrieve the consent from the window, then from the
 * cookie.
 *
 * If unable to retrieve a cookie, it returns the default of no consent other than necessary.
 *
 * @returns {object}
 */
export const getConsent = () =>
  getConsentFromWindow() ?? getConsentFromCookie() ?? DEFAULT_CONSENT;
